//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
import CopyBox from '../components/bbcode/copy-box';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import './css/adminlte.css';
import './css/djarea.css';

export default class DJAreaFiles extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			

		};
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
		this.setState({status: true});
	}

	componentWillUnmount() {
	}

	render() {
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				{this.state.status &&
					<Col>
					
						<div className="card bg-dark">
							<div className="card-header">
								<h3 className="card-title">Downloads Drops & Jingles</h3>
							</div>
							<div className="card-body">
								You can find Drops, Jingles, OBS stages and other files that are availble for download here<br /><br />
								<Row>
									<Col xs={2}>
										Address:<br />
										<CopyBox content="https://files.mix365.co.uk" />
									</Col>
									<Col xs={2}>
										Username:<br />
										<CopyBox content="mix365dj" />
									</Col>
									<Col xs={2}>
										Password:<br />
										<CopyBox content="iamadj2022" />
									</Col>
									<Col xs={2} className="text-vcenter">
										<a href="https://files.mix365.co.uk" target="_blank" rel="noreferrer">
											<Button>Open in new browser tab</Button>
										</a>
									</Col>
								</Row>
							</div>
						</div>
						{/*<iframe src="https://nx32903.your-storageshare.de/login" width="100%" height="500" title="Mix365 Files" />*/}

					</Col>
				}
			</Row>
		);
	}
}
